export default __webpack_public_path__ + "static/media/ailoading.8b3295f2.gif";